import { render, staticRenderFns } from "./tableTotalWrap.vue?vue&type=template&id=25da8411&"
import script from "./tableTotalWrap.vue?vue&type=script&lang=js&"
export * from "./tableTotalWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports